import React, { useEffect, useState } from 'react';
import HistoryIcon from '@mui/icons-material/History';
import { rulesAPI } from '../../services/api';
import { permissionError } from '../../hooks/useRules';
import './RulesPermissions.css';

const SCOPE_LABELS = { company: 'Company rule' };

function describeScope(scope) {
  if (!scope) return '';
  if (SCOPE_LABELS[scope]) return SCOPE_LABELS[scope];
  if (scope.startsWith('team:')) return `Team rule · ${scope.slice(5)}`;
  if (scope.startsWith('campaign:')) return `Campaign ${scope.slice(9, 17)}…`;
  return scope;
}

function when(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  return `${d.toLocaleDateString()} ${d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
}

/** Who changed which rule or campaign access, newest first. */
export default function RulesAuditLog() {
  const [rows, setRows] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    rulesAPI.audit(200)
      .then((res) => setRows(Array.isArray(res.data) ? res.data : []))
      .catch((err) => setError(permissionError(err, 'Could not load the audit log.')));
  }, []);

  return (
    <div className="rp">
      <div className="rp-head">
        <div>
          <h2><HistoryIcon style={{ fontSize: 20 }} /> Audit log</h2>
          <p className="rp-muted">Every change to Wizetok&apos;s Rules &amp; Permissions and to campaign access (assign, lock, transfer, ReachOut link).</p>
        </div>
      </div>
      <section className="rp-card">
        {error && <div className="rp-empty">{error}</div>}
        {!error && rows === null && <div className="rp-empty">Loading…</div>}
        {!error && rows && rows.length === 0 && <div className="rp-empty">No changes yet.</div>}
        {!error && rows && rows.map((r) => (
          <div key={r.id} className="rp-audit-row">
            <div className="rp-muted" style={{ margin: 0 }}>{when(r.changedAt)}</div>
            <div>
              <b>{r.ruleKey}</b>{r.roleKind ? ` · ${r.roleKind}` : ''}
              <div className="rp-muted" style={{ margin: 0 }}>
                {describeScope(r.scope)}: {r.oldValue ?? '—'} → <b>{r.newValue ?? '—'}</b>
              </div>
            </div>
            <div className="rp-muted" style={{ margin: 0 }}>{r.changedBy || '—'}</div>
          </div>
        ))}
      </section>
    </div>
  );
}
